import React, { FC, ChangeEvent } from "react";
import styled from "styled-components";
import LabelText from "./LabelText";
import LabelNumber from "../styled-components/LabelNumber";

const Slider = styled.span<{ toggled: boolean; source: string; isByComparison: boolean; type: string;}>`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${({ source, theme, isByComparison }) => source === 'Sidebar' ? "black": isByComparison ? "#4a4a49" : theme.notificationTitleColor};
  border-radius: 18px;
  border: 3px solid gray;
  transition: 0.4s;
  cursor: pointer;

  &:before {
    content: "";
    position: absolute;
    left: ${({ toggled }) => (toggled ? '0px' : '2px')};
    bottom: 1px;
    top: 50%;
    width: 12px;
    height: 12px;
    border-radius: 100%;
    background-color: ${({ toggled, type, theme }) => toggled || type === 'valueGraph' || type === 'attributes' ? "#00D1A8" : theme.matchLabel};
    transition: 0.4s;
    transform: translateY(-50%);
  }
`;


const Input = styled.input`
  &:checked + ${Slider}:before {
    transform: translateY(-50%) translateX(20px)
  }
`;

const SwitchContainer = styled.label<{ toggled: boolean }>`
  position: relative;
  display: inline-block;
  width: 40px;
  height: 20px;
  backgroud-color: ${({ toggled, color }) => (toggled ? "#0AFC7F" : "white")};
  border-radius: 18px;
  transition: 0.4s;

  & ${Input} {
    opacity: 0;
    width: 0;
    height: 0;
  }
`;

interface SwitchProps {
  id: string;
  toggled: boolean;
  onChange?: (event: any) => void;
  source?: string;
  title?: string;
  isByComparison?:boolean;
  type?: string
}

const Switch: FC<SwitchProps> = ({ id, toggled, onChange, source, title , isByComparison , type }) => {
  const color = '#6ab04c'
  return (
    <div className="pitch-widget-switch">
      {type === 'valueGraph' && <LabelNumber onClick={onChange} className='valuegraph-toggle-text' style={{ color: !toggled ? "#00D1A8" : "" ,cursor:'pointer'}}>Universal</LabelNumber>}
      <SwitchContainer toggled={toggled} >
        <Input {...{ color }} type="checkbox" checked={toggled} />
        <Slider {...{ toggled, color , isByComparison }} onClick={onChange} toggled={toggled} source={source!} isByComparison={isByComparison!} type={type!}/>
      </SwitchContainer>
      {title ? (
    type === 'valueGraph' ? (
        <LabelNumber 
            className="valuegraph-toggle-text" 
            style={{ color: toggled ? "#00D1A8" : "" ,cursor:'pointer'}} 
            {...(title === 'League' ? { onClick: onChange } : {})} // Corrected conditional onClick
        >
            {title}
        </LabelNumber>
    ) : (
        <LabelText className={isByComparison ? "comparison-score-text" : ""}>
            {title}
        </LabelText>
    )
) : null}


    </div>
  );
};

export default Switch;
